import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "g-grid-container" }
const _hoisted_2 = ["onClick"]

import { ref, type Ref, toRefs, computed, type StyleValue, provide } from "vue"

import useTimePositionMapping from "../composables/useTimePositionMapping"
import provideConfig from "../provider/provideConfig"
import type { GanttBarObject } from "../types"
import GGanttBar from "./GGanttBar.vue"
import { BAR_CONTAINER_KEY } from "../provider/symbols"
import useTimeaxisUnits from "../composables/useTimeaxisUnits"

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'GGanttRow',
  props: {
    label: {},
    bars: {},
    highlightOnHover: { type: Boolean },
    highlightedUnits: {}
  },
  emits: ["drop", "clickedTime"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const { timeaxisUnits } = useTimeaxisUnits()

// eslint-disable-next-line no-undef
const emit = __emit

const { rowHeight, colors, labelColumnTitle } = provideConfig()
const { highlightOnHover } = toRefs(props)
const isHovering = ref(false)

const rowStyle = computed(() => {
  return {
    height: `${rowHeight.value + 6}px`,
    background: highlightOnHover?.value && isHovering.value ? colors.value.hoverHighlight : null
  } as StyleValue
})

const { mapPositionToTime } = useTimePositionMapping()
const barContainer: Ref<HTMLElement | null> = ref(null)

provide(BAR_CONTAINER_KEY, barContainer)

const onDrop = (e: MouseEvent) => {
  const container = barContainer.value?.getBoundingClientRect()
  if (!container) {
    console.error("Vue-Ganttastic: failed to find bar container element for row.")
    return
  }
  const xPos = e.clientX - container.left
  const datetime = mapPositionToTime(xPos)
  emit("drop", { e, datetime })
}

const isBlank = (str: string) => {
  return (!str || /^\s*$/.test(str))
}

const clickTime = (e: MouseEvent, value: string|Date) => {
  emit("clickedTime", { e, value })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "g-gantt-row",
    style: _normalizeStyle(rowStyle.value),
    onDragover: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isHovering.value = true), ["prevent"])),
    onDragleave: _cache[1] || (_cache[1] = ($event: any) => (isHovering.value = false)),
    onDrop: _cache[2] || (_cache[2] = ($event: any) => (onDrop($event))),
    onMouseover: _cache[3] || (_cache[3] = ($event: any) => (isHovering.value = true)),
    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (isHovering.value = false))
  }, [
    (!isBlank(_ctx.label) && !_unref(labelColumnTitle))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "g-gantt-row-label",
          style: _normalizeStyle({ background: _unref(colors).primary, color: _unref(colors).text })
        }, [
          _renderSlot(_ctx.$slots, "label", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _mergeProps({
      ref_key: "barContainer",
      ref: barContainer,
      class: "g-gantt-row-bars-container"
    }, _ctx.$attrs), [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeaxisUnits).lowerUnits, ({ label, value, width }) => {
          return (_openBlock(), _createElementBlock("div", {
            key: label,
            class: "test",
            style: _normalizeStyle({
            width,
            background: _ctx.highlightedUnits?.includes(Number(value))
              ? _unref(colors).hoverHighlight
              : undefined,
            height: `${_unref(rowHeight)}px`
          }),
            onClick: ($event: any) => (clickTime($event, value))
          }, null, 12, _hoisted_2))
        }), 128))
      ]),
      _createVNode(_TransitionGroup, {
        name: "bar-transition",
        tag: "div"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bars, (bar) => {
            return (_openBlock(), _createBlock(GGanttBar, {
              key: bar.ganttBarConfig.id,
              bar: bar
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "bar-label", { bar: bar })
              ]),
              _: 2
            }, 1032, ["bar"]))
          }), 128))
        ]),
        _: 3
      })
    ], 16)
  ], 36))
}
}

})